export default "__VITE_ASSET__81246985__"